<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :height="200"
      size="small"
      resizable
      border
      ref="vxeGrid"
    >
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_downloada') || '下载'"
            placement="top"
          >
            <i class="el-icon-download tool-btn" @click="downloadFile(row)"></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: { tableData: { type: Array, default: () => [] } },
  data() {
    return { tableColumns: tableColumns(this) }
  },
  methods: {
    downloadFile({ fileCode = '' }) {
      this.$api.SYS_FILEDOWNLOAD(fileCode)
    },
  },
}
</script>
